import { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Minimal editorial cursor: a small ring that grows over interactive targets.
export default function CursorDot() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [active, setActive] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const move = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
      setVisible(true);
      const el = e.target;
      const interactive = el.closest("a, button, [data-cursor='hover']");
      setActive(!!interactive);
    };
    const leave = () => setVisible(false);
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseout", leave);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseout", leave);
    };
  }, []);

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-[120] hidden mix-blend-difference md:block"
      animate={{
        x: pos.x,
        y: pos.y,
        opacity: visible ? 1 : 0,
        scale: active ? 2.6 : 1,
      }}
      transition={{ type: "spring", stiffness: 500, damping: 40, mass: 0.4 }}
      style={{ translateX: "-50%", translateY: "-50%" }}
    >
      <div className="h-3 w-3 rounded-full bg-white" />
    </motion.div>
  );
}
